import { Position } from "@xyflow/react";
import { memo } from "react";
import { MdDelete } from "react-icons/md";
import CircleButton from "widgets/controls/buttons/circle-button";
import { ZoneNodeData } from "../flow-utils";
import RectangleHandle from "../../handles/rectangle";
import { TbCircleLetterZ } from "react-icons/tb";

function ZoneNode(props: { data: ZoneNodeData }) {
  const { data } = props;
  const leafNodes = data.leafNodes || [];

  return (
    <div
      className={`border-stone-400 min-w-52 rounded-3xl border-2  bg-white px-4 py-2 shadow-lg`}
      style={{ width: data.width, height: data.height }}
      key={data.id}
    >
      {/* Node content */}
      <div className="flex h-full flex-col justify-between p-1">
        <div className="relative flex justify-center">
          <div
            className="truncate text-center text-lg font-bold text-primary"
            style={{ maxWidth: data.width - 10 }}
          >
            {data.name}
          </div>
          <div className="absolute right-0">
            <TbCircleLetterZ className="text-3xl text-red-500" />
          </div>
        </div>

        {/* Node content */}
        <div
          className="nowheel min-h-0 flex-1 overflow-y-auto py-3"
          key={data.id}
        >
          <div className="flex flex-col gap-2">
            {leafNodes.map((leaf, index) => (
              <div
                key={leaf.device.snr}
                className="flex items-center justify-between"
              >
                <div className="flex flex-col">
                  <div className="text-sm font-bold text-primary">
                    {leaf.label}
                  </div>
                  <div className="truncate text-xs text-secondary">
                    SNR: {leaf.device.snr}
                  </div>
                </div>
                {data.onRemoveDevice && (
                  <CircleButton
                    extra="nodrag"
                    icon={MdDelete}
                    variant="ghost"
                    size="xs"
                    onClick={() =>
                      data.onRemoveDevice?.(data.id, leaf.device.snr)
                    }
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom buttons - only in builder mode */}
        {data.onDelete && (
          <div className="nodrag flex justify-end">
            <CircleButton
              label="REMOVE"
              size="xs"
              color="red"
              onClick={() => data.onDelete?.(data.id)}
            />
          </div>
        )}
      </div>

      {/* Target handle - flow in */}
      <RectangleHandle
        type="target"
        position={data.targetPosition ?? Position.Left}
        width={data.width}
        height={data.height}
      />

      {/* Source handle - flow out */}
      <RectangleHandle
        type="source"
        position={data.sourcePosition ?? Position.Right}
        width={data.width}
        height={data.height}
      />
    </div>
  );
}

export default memo(ZoneNode);
